import React from "react";

const SvgBBiconsGrKontaktniUdaje = props => (
  <svg data-name="Global report" viewBox="0 0 200 200" {...props}>
    <path
      data-name="Kontaktni udaje"
      d="M76.83 31.83a42.75 42.75 0 00-42.76 42.76c0 8.4 5.76 24.12 15.81 44.56 2.19 4.45 4.54 9.07 7 13.82a694.57 694.57 0 0016 28.55c1.42 2.44 2.68 4.55 3.94 6.65v-48.61a10.9 10.9 0 0110.86-11h21c6.89-15.22 10.91-27.16 10.91-34a42.75 42.75 0 00-42.76-42.73zm1.5 20.55a16.69 16.69 0 11-16.66 16.69 16.67 16.67 0 0116.66-16.69zm9.29 61.77a4.34 4.34 0 00-4.31 4.37v45.27a4.35 4.35 0 004.31 4.38h74a4.34 4.34 0 004.3-4.38v-45.27a4.33 4.33 0 00-4.3-4.37zm69.68 5.39a2.39 2.39 0 011.62.89 2.44 2.44 0 01-.41 3.42l-30.78 24.33a5.13 5.13 0 01-6.22 0L90.9 124a2.43 2.43 0 01-.39-3.42 2.4 2.4 0 013.39-.39l30.61 24.19h.22L155.51 120a2.41 2.41 0 011.79-.46zm-50 25.42a2.42 2.42 0 011.23 4.31L94 160.83a2.43 2.43 0 11-3-3.8l14.65-11.57a2.37 2.37 0 011.7-.46zm34.68.11a2.37 2.37 0 011.79.5l14.65 11.58a2.43 2.43 0 11-3 3.81l-14.62-11.58a2.43 2.43 0 011.23-4.31z"
    />
  </svg>
);

export default SvgBBiconsGrKontaktniUdaje;
